import styled from 'styled-components';
import { Col } from 'antd';
import { theme } from 'consts/themeBase';

export const StyledCol = styled(Col)`
  width: 100%;
  height: 15px;
  line-height: 0px;
  background-color: ${theme.colors.white};
  align-items: center;
  padding: 4px 16px 0px 16px;
`;
